import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form__checkbox-item" };
const _hoisted_2 = ["id", "name", "value", "checked"];
const _hoisted_3 = ["for"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'TopicFilterCheckboxItem',
    props: {
        item: {}
    },
    emits: ['update:checked'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    type: "checkbox",
                    class: "form__checkbox-input",
                    id: _ctx.item.id,
                    name: _ctx.item.id,
                    value: _ctx.item.value,
                    checked: _ctx.item.checked,
                    onChange: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:checked', $event.target?.checked)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
                _createElementVNode("label", {
                    for: _ctx.item.id,
                    class: "form__checkbox-label"
                }, _toDisplayString(_ctx.item.title), 9 /* TEXT, PROPS */, _hoisted_3)
            ]));
        };
    }
});
